var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("div", {
    staticClass: "page-login--layer page-login--layer-area"
  }, [_c("ul", {
    staticClass: "circles"
  }, _vm._l(10, function (n) {
    return _c("li", {
      key: n
    });
  }), 0)]), _c("div", {
    staticClass: "page-login--layer page-login--layer-time",
    attrs: {
      flex: "main:center cross:center"
    }
  }, [_vm._v(" " + _vm._s(_vm.time) + " ")]), _c("div", {
    staticClass: "page-login--layer"
  }, [_c("div", {
    staticClass: "page-login--content",
    attrs: {
      flex: "dir:top main:justify cross:stretch box:justify"
    }
  }, [_vm._m(0), _c("div", {
    staticClass: "page-login--content-main",
    attrs: {
      flex: "dir:top main:center cross:center"
    }
  }, [_vm.sys_login_logo ? _c("img", {
    staticClass: "page-login--logo",
    attrs: {
      src: _vm.sys_login_logo
    }
  }) : _c("img", {
    staticClass: "page-login--logo",
    attrs: {
      src: require("./image/logo@2x.png")
    }
  }), _c("div", {
    staticClass: "page-login--form"
  }, [_c("el-tabs", {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_c("el-tab-pane", {
    attrs: {
      label: "账号密码",
      name: "password"
    }
  }, [_c("el-card", {
    attrs: {
      shadow: "never"
    }
  }, [_c("el-form", {
    ref: "loginForm",
    attrs: {
      "label-position": "top",
      rules: _vm.rules,
      model: _vm.formLogin,
      size: "default"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      prop: "username"
    }
  }, [_c("el-input", {
    attrs: {
      type: "text",
      placeholder: "帐号"
    },
    model: {
      value: _vm.formLogin.username,
      callback: function callback($$v) {
        _vm.$set(_vm.formLogin, "username", $$v);
      },
      expression: "formLogin.username"
    }
  }, [_c("i", {
    staticClass: "fa fa-user-circle-o",
    attrs: {
      slot: "prepend"
    },
    slot: "prepend"
  })])], 1), _c("el-form-item", {
    attrs: {
      prop: "password"
    }
  }, [_c("el-input", {
    attrs: {
      type: "password",
      placeholder: "密码"
    },
    model: {
      value: _vm.formLogin.password,
      callback: function callback($$v) {
        _vm.$set(_vm.formLogin, "password", $$v);
      },
      expression: "formLogin.password"
    }
  }, [_c("i", {
    staticClass: "fa fa-keyboard-o",
    attrs: {
      slot: "prepend"
    },
    slot: "prepend"
  })])], 1), _c("el-button", {
    staticClass: "button-login",
    attrs: {
      size: "default",
      type: "primary"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("登录")])], 1)], 1)], 1), _vm.wechatLogin ? _c("el-tab-pane", {
    attrs: {
      label: "微信扫码",
      name: "code"
    }
  }, [_c("el-card", {
    attrs: {
      shadow: "never"
    }
  }, [_c("div", {
    attrs: {
      id: "code-container"
    }
  })])], 1) : _vm._e()], 1)], 1)]), _c("div", {
    staticClass: "page-login--content-footer"
  }, [_c("p", {
    staticClass: "page-login--content-footer-copyright"
  }, [_vm._v(" Copyright "), _c("d2-icon", {
    attrs: {
      name: "copyright"
    }
  }), _vm._v(" 2022 "), _c("a", {
    attrs: {
      href: "http://www.beian.miit.gov.cn/",
      target: "_blank"
    }
  }, [_vm._v(_vm._s(_vm.about.sysRecord))])], 1)])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login--content-header"
  }, [_c("p", {
    staticClass: "page-login--content-header-motto"
  }, [_vm._v(" ")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };